import {EventTypeConstants} from '../../constants/event-type.constants';
import {EventLogReferrerConstants} from '../../constants/event-log-referrer.constants';

export class LogEventDtls{
  eventType : EventTypeConstants ;
  msg1 : string  ;
  msg2 : string ;
  referrer? : EventLogReferrerConstants;
}
